export default {
      id: "i-tg-circle-dark-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/sprite.svg#i-tg-circle-dark",
      toString: function () {
        return this.url;
      }
    }